import React, { useState } from "react";
import { BadgeCheck, FileCheck2, ShieldQuestion, Store, Flag, HelpCircle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { useLang } from "../context/LanguageContext";

const Line = ({ icon: Icon, tone, title, body }) => (
  <div className="flex items-start gap-3">
    <span className={`h-9 w-9 rounded-xl flex items-center justify-center shrink-0 ${tone}`}><Icon size={17} /></span>
    <div>
      <p className="text-sm font-bold text-foreground">{title}</p>
      <p className="text-sm text-muted-foreground">{body}</p>
    </div>
  </div>
);

/** Tappable "what does verified mean?" note, so the badge builds real confidence. */
export const TrustExplainer = ({ trigger, testid = "trust-explainer-trigger" }) => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <>
      <button onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(true); }} data-testid={testid}
        className="inline-flex items-center gap-1 text-xs font-semibold text-muted-foreground hover:text-[#16a34a] transition-colors">
        {trigger || <><HelpCircle size={13} /> {t("trust.whatsThis")}</>}
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="trust-explainer-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><BadgeCheck size={20} className="text-[#16a34a]" /> {t("trust.title")}</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <Line icon={FileCheck2} tone="bg-[#e7f6ec] text-[#15803d]" title={t("trust.verifiedTitle")} body={t("trust.verifiedBody")} />
            <Line icon={Store} tone="bg-secondary text-muted-foreground" title={t("trust.independentTitle")} body={t("trust.independentBody")} />
            <Line icon={ShieldQuestion} tone="bg-amber-100 text-amber-700" title={t("trust.limitsTitle")} body={t("trust.limitsBody")} />
            <Line icon={Flag} tone="bg-rose-100 text-rose-600" title={t("trust.reportTitle")} body={t("trust.reportBody")} />
            <p className="text-xs text-muted-foreground border-t border-border pt-3">{t("trust.footer")}</p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TrustExplainer;
